<template>
  <div>
    <div class="hiaTable truCodeEnabled VueTables VueTables--client table-responsive">
      <table class="VueTables__table table table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th class="VueTables__sortable tenPercent">
              <span class="VueTables__heading">Orig. CPT</span>
            </th>
            <th class="VueTables__sortable">
              <span class="VueTables__heading">Mods</span>
            </th>
            <th class="VueTables__sortable thirtyFivePercent">
              <span class="VueTables__heading">Desc</span>
            </th>
            <th class="VueTables__sortable tenPercent">
              <span class="VueTables__heading">Rec. CPT </span>
            </th>
            <th class="VueTables__sortable">
              <span class="VueTables__heading">Mods</span>
            </th>
            <th class="VueTables__sortable">
              <span class="VueTables__heading">Desc</span>
            </th>
            <th class="VueTables__sortable tenPercent">
              <span class="VueTables__heading">Reason For Change</span>
            </th>
            <th class="VueTables__sortable">
              <span class="VueTables__heading"></span>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(value, key, index) in compGroupCPTs">
            <tr :id="index" class="codeTypeHeader" :key="key">
              <td colspan="8">
                {{ key }}
              </td>
            </tr>
            <tr v-for="value2 in value" :key="value2.cptId" :class="value2.recommendedCpt || value2.deleteOriginal ? 'VueTables__row  highlight' : 'VueTables__row'">
              <td>
                <div>{{ value2.originalCPT }}</div>
              </td>
              <td>
                <div v-html="cptModifiers(value2.originalModifiers)"></div>
              </td>
              <td>
                <div style="text-transform: lowercase;" :title="value2.origDesc">
                  {{ truncateDescription(value2.origDesc) }}
                  <span v-if="value2.originalGrouperFlags" :title="getGrouperflagsTitle(value2.originalGrouperFlags)" class="grouperFlags">({{ value2.originalGrouperFlags }})</span>
                </div>
              </td>
              <td>
                <div>{{ value2.recommendedCpt }}</div>
              </td>
              <td>
                <div v-html="cptModifiers(value2.recommendedModifiers)"></div>
              </td>
              <td>
                <div style="text-transform: lowercase;" :title="value2.recDesc">
                  {{ truncateDescription(value2.recDesc) }}

                  <span :title="getGrouperflagsTitle(value2.recommendedGrouperFlags)" v-if="(value2.recommendedDx && value2.recommendedGrouperFlags) || (value2.recommendedGrouperFlags && value2.recommendedGrouperFlags !== value2.originalGrouperFlags)" class="grouperFlags">({{ value2.recommendedGrouperFlags }})</span>
                </div>
              </td>
              <td>
                {{ value2.reasonForChangeDesc }}
              </td>
              <td>
                <el-button style="margin-right: 5px;" size="mini" v-if="(value2.recommendedCpt || value2.originalDeleted) && !(worksheet.hideExcludedCodesResponseFromNucleus && value2.codeType === 9)" type="text" @click="addResponse(value2)" :disabled="readOnly">Respond </el-button>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <div style="color: #909399; margin: 0px 0px 0px 5px;" v-if="!compGroupCPTs.length">Not matching records</div>
    </div>
  </div>
</template>

<script>
import dateHelper from '@/mixins/date-helper'
import HiaAuthorization from '@/mixins/hiaAuthorization'
import { format, parseISO } from 'date-fns'
import { mapMutations } from 'vuex'

export default {
  name: 'coderInpatientPxs',
  mixins: [dateHelper, HiaAuthorization],
  props: ['worksheet', 'readOnly'],
  data() {
    return {
      format: format,
      parseISO: parseISO,
      disabled: true,
      loading: false,
      pxColumns: ['originalCPT', 'originalModifiers', 'origDesc', 'recommendedCpt', 'recommendedModifiers', 'recDesc', 'reasonForChangeDesc', 'response'],
      options: {
        filterable: false,
        filterByColumn: false,
        resizableColumns: false,
        queue: [],
        networkFunction: null,
        perPage: 100,
        rowClassCallback: row => {
          if (row.recommendedCpt || row.deleteOriginal) {
            return 'highlight'
          }
          return ''
        },
        columnsClasses: {
          originalCPT: 'tenPercent',
          origDesc: 'thirtyFivePercent',
          recommendedCpt: 'tenPercent',
          recDescription: 'thirtyFivePercent',
          reasonForChangeDesc: 'tenPercent'
        },
        headings: {
          originalCPT: 'Original CPT',
          origDesc: 'Desc.',
          recommendedCpt: 'Recommended CPT',
          recDesc: 'Desc.',
          reasonForChange: 'Reason For Change',
          response: '',
          reasonForChangeDesc: 'Reason For Change'
        },
        customSorting: {
          originalCPT: function(ascending) {},
          originalModifiers: function(ascending) {},
          origDesc: function(ascending) {},
          recommendedCpt: function(ascending) {},
          recommendedModifiers: function(ascending) {},
          recDesc: function(ascending) {},
          reasonForChangeDesc: function(ascending) {},
          response: function(ascending) {}
        }
      }
    }
  },
  methods: {
    ...mapMutations('myProjects/', ['SET_RESPONSE_ROW']),
    truncateDescription(description) {
      const max = 100
      if (description && description.length > max) {
        return description.substring(0, max) + '...'
      }
      return description
    },
    getGrouperflagsTitle(flagList) {
      if (!flagList) {
        return
      }

      const flagMap = {
        AD: 'Affects DRG',
        CC: 'Complication/Comorbidity',
        HC: 'Hospital-Acquired Condition',
        MC: 'Complication/Comorbidity',
        R: 'Affects Risk of Mortality',
        S: 'Affects Severity of Illness',
        AP: 'Affects Patient Safety Indicators',
        EP: 'Excludes Patient Safety Indicators',
        AQ: 'Affects Quality Measures',
        EQ: 'Excludes Quality Measures',
        OR: 'Operative Procedure',
        NOR: 'Non-Operative Procedure'
      }

      const flags = flagList.split(',')
      const title = []
      flags.forEach(x => {
        title.push(`${x}: ${flagMap[x]}`)
      })

      return title.join('\n')
    },
    addResponse(row) {
      this.SET_RESPONSE_ROW(row)
    },
    getPhysicianFeeScheduleData(cpt, field, level) {
      let data = null
      switch (level) {
        case 0:
          data = cpt.originalCPT ? this.worksheet.proRecordCptsPhysicianFeeSchedule.find(f => f.cptId === cpt.cptId && f.codeLevel === level) : null
          break
        case 1:
          data = cpt.recommendedCpt ? this.worksheet.proRecordCptsPhysicianFeeSchedule.find(f => f.cptId === cpt.cptId && f.codeLevel === level) : null
          break
        case 2:
          data = cpt.level2Cpt ? this.worksheet.proRecordCptsPhysicianFeeSchedule.find(f => f.cptId === cpt.cptId && f.codeLevel === level) : null
          break
      }
      return data ? data[field] : '&nbsp;'
    },
    getGlobalSurgeryTitle(val) {
      const map = {
        '000': '000 - Endoscopic or minor procedure with related preoperative and postoperative relative values on the day of the procedure only included in the fee schedule payment amount; evaluation and management services on the day of the procedure generally not payable.',
        '010': '010 - Minor procedure with preoperative relative values on the day of the procedure and postoperative relative values during a 10 day postoperative period included in the fee schedule amount; evaluation and management services on the day of the procedure and during the 10-day postoperative period generally not payable.',
        '090': '090 - Major surgery with a 1-day preoperative period and 90-day postoperative period included in the fee schedule amount.',
        MMM: 'MMM - Maternity codes; usual global period does not apply.',
        XXX: 'XXX - The global concept does not apply to the code.',
        YYY: 'YYY - The carrier is to determine whether the global concept applies and establishes postoperative period, if appropriate, at time of pricing.',
        ZZZ: 'ZZZ - The code is related to another service and is always included in the global period of the other service.'
      }
      return map[val]
    },
    cptModifiers(modifiers) {
      if (modifiers) {
        const newMods = modifiers
          .replaceAll('-', '')
          .split(' ')
          .filter(Boolean)
          .join(',')
        return newMods
      }
      return '&nbsp;'
    }
  },
  computed: {
    compGroupCPTs() {
      return this.worksheet.cpts ? Object.groupBy(this.worksheet.cpts, ({ codeDesc }) => codeDesc) : []
    }
  }
}
</script>

<style scoped>
.grouperFlags {
  font-style: italic;
  text-transform: uppercase;
}

>>> .tenPercent {
  width: 10%;
}

>>> .twentyPercent {
  width: 20%;
}

>>> .thirtyFivePercent {
  width: 30%;
}

>>> .highlight {
  /* background-color: rgba(255, 196, 12, 0.1) !important; */
  font-weight: bold;
}

>>> .highlight {
  border-left: 3px solid #f56c6c;
}

/* >>>.highlight:hover {
    background-color: rgba(255, 196, 12, 0.2) !important;
  } */

>>> td {
  font-size: 13px !important;
}

>>> .feeScheduleHeader {
  color: #005695;
  border-top: 1px solid rgb(204, 204, 204);
  margin-top: 2px;
  padding-top: 2px;
  font-weight: normal;
  font-size: 11px;
}

>>> .feeScheduleData {
  border-top: 1px solid rgb(204, 204, 204);
  padding-top: 5px;
  font-size: 11px;
  position: absolute;
  bottom: 0px;
  margin: 10px 0px 10px 0px;
  width: 100%;
  color: #005695;
}

>>> #cptGrid.truCodeEnabled td {
  position: relative;
  padding-bottom: 32px;
}

>>> .codeTypeHeader {
  text-align: center;
  background: rgb(28, 60, 95) !important;
  color: #ffffff;
  font-weight: bold;
}
</style>
